'use client';

import { Input } from '../ui';

export function ImageDropzone(props: {
  onDrop: (files: FileList | null) => void;
}) {
  return (
    <div className="w-64">
      <Input
        className="transition-colors hover:cursor-pointer hover:bg-gray-50"
        type="file"
        accept="image/*"
        onChange={(e) => props.onDrop(e.target.files)}
      />
    </div>
  );
}
